(() => {
  if (window.__lpAtcBound) return;
  window.__lpAtcBound = true;

  const cartAdd =
    (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  const UPDATING_CLASS = 'lp-atc-updating';
  const UPDATING_TIMEOUT = 8000;

  // Open the cart drawer right away with a loader, and clear the loader
  // once the theme re-renders the cart items after `ajaxProduct:added`.
  const showDrawerLoading = () => {
    if (!document.body.classList.contains('template-unlock-hydration')) return null;
    const drawer = document.getElementById('CartDrawer');
    const products = drawer && drawer.querySelector('[data-products]');
    if (!drawer || !products) return null;

    drawer.classList.add(UPDATING_CLASS);
    // Defer so the current click doesn't reach the drawer's outside-click close handler
    setTimeout(() => document.dispatchEvent(new CustomEvent('cart:open')));

    let timer = 0;
    const observer = new MutationObserver(() => done());
    const done = () => {
      observer.disconnect();
      clearTimeout(timer);
      drawer.classList.remove(UPDATING_CLASS);
    };

    return {
      watch() {
        observer.observe(products, { childList: true });
        timer = setTimeout(done, UPDATING_TIMEOUT);
      },
      cancel() {
        done();
        document.dispatchEvent(new CustomEvent('cart:close'));
      },
    };
  };

  window.lpAtcDrawerLoading = showDrawerLoading;

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-lp-atc]');
    if (!btn) return;

    event.preventDefault();
    if (btn.disabled || btn.getAttribute('data-available') === 'false') return;

    const variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;

    const item = { id: variantId, quantity: 1 };
    const sellingPlanId = Number(btn.getAttribute('data-selling-plan-id'));
    if (sellingPlanId) item.selling_plan = sellingPlanId;

    btn.classList.add('is-loading');
    btn.disabled = true;
    const drawerLoading = showDrawerLoading();
    let added = false;

    try {
      const response = await fetch(cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [item] }),
      });
      const data = await response.json();
      if (data.status === 422 || data.message) return;

      added = true;
      if (drawerLoading) drawerLoading.watch();

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: data, addToCartBtn: btn },
        }),
      );
    } finally {
      if (!added && drawerLoading) drawerLoading.cancel();
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  });
})();
